import React, { useCallback, useRef, useState, useEffect, Ref } from 'react'
import {
  message,
  Modal,
  TreeSelect,
  Card,
  Avatar,
  Tag,
  Spin,
  Timeline,
  Radio,
  Row,
  Col,
  Button,
  Divider,
} from 'antd'
import {
  SBack,
  SLowcodeList,
  SGeneralForms,
  SListTabs,
  STitle,
  SSegmentedTabs,
  SDrawerOrModal,
} from 'shj-components'
import { useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom'
import styles from '../index.module.less'
import dayjs from 'dayjs'
import SelectLabel from '../components/selectLabel'
import SourceInformation from './sourceInformation'
import BasicInfo from '@/components/BasicInfo'
import FollowRecord from '@/components/FollowRecord'
import ServiorInfo from '@/components/ServiorInfo'
import OrderInfo from '@/components/OrderInfo'
import avatarNew from '@/assets/avatar-new.png'
import {
  getCustomerMemberInfo,
  queryAllTags,
  getDetailByBizOpId,
  getTrackPlanLog,
  getTrackPlanRelatives,
} from '@/services/customerServices.ts'

const colorList = [
  {
    borderColor: 'rgba(250, 96, 80, 1)',
    fontColor: 'rgba(242, 90, 10, 1)',
  },
  {
    borderColor: 'rgba(0, 100, 255, 1)',
    fontColor: 'rgba(0, 100, 255, 1)',
  },
  {
    borderColor: 'rgba(245, 147, 0, 1)',
    fontColor: 'rgba(245, 147, 0, 1)',
  },
  {
    borderColor: 'rgba(112, 163, 16, 1)',
    fontColor: 'rgba(112, 163, 16, 1)',
  },
]

const Details = () => {
  const staffRef = useRef()
  const location = useLocation()
  const [search] = useSearchParams()
  const { id, customerId } = useParams()
  const { readOnly } = location.state || {}
  console.log('readOnly===>', search, readOnly, location)
  const [isVisible, setIsVisible] = useState(false)
  const [infoChoice, setInfoChoice] = useState('a')
  const [boardChoice, setBoardChoice] = useState('a')
  // 行为动态
  const [behaviorList, setBehaviorList] = useState([
    {
      children: (
        <div>
          <div className={styles.followTime}>
            <span style={{ paddingRight: 10 }}>{'2024-10-1 11:11:11'}</span>
          </div>
          <div>扫码到店 | 成都生活家</div>
        </div>
      ),
    },
    {
      children: (
        <div>
          <div className={styles.followTime}>
            <span style={{ paddingRight: 10 }}>{'2024-10-1 11:11:11'}</span>
          </div>
          <div>扫码到店 | 成都生活家</div>
          <div>名称 | 成都生活家</div>
        </div>
      ),
    },
  ])
  const [loading, setLoading] = useState(false)
  const [trackPlanInfo, setTrackPlanInfo] = useState({})
  const [trackPlanInfoList, setTrackPlanInfoList] = useState<Array<any>>([])
  const [trackPlanLogInfo, setTrackPlanLogInfo] = useState([])
  const [detailsInfo, setDetailsInfo] = useState({
    customerInfo: {},
    memberInfo: {},
  })
  const [drawTagList, setDrawTagList] = useState<Array<any>>([])
  const [trackPlanReletiveInfo, setTrackPlanReletiveInfo] = useState([])

  useEffect(() => {
    if (customerId) {
      fetchCustomerMemberInfo(customerId)
    }
    if (id) {
      fetchTrackPlanInfo(id)
      fetchDrawTags(id)
    }
  }, [id, customerId])

  const fetchTrackPlanInfo = async (bizOpId: any) => {
    try {
      setLoading(true)
      const res: any = (await getDetailByBizOpId(bizOpId)) || {}
      setLoading(false)
      if (res) {
        const newList = res.map(item => ({
          ...item,
          infoChoice: 'a',
          trackPlanLogInfo: [],
          trackPlanReletiveInfo: [],
        }))
        setTrackPlanInfoList(newList)
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const fetchCustomerMemberInfo = async (customerId: any) => {
    try {
      setLoading(true)
      const res: any = (await getCustomerMemberInfo(customerId)) || {}
      setLoading(false)
      if (res) {
        setDetailsInfo(res)
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  // 跟进记录
  const fetchTrackPlanLog = async (trackPlanId: any) => {
    try {
      setLoading(true)
      const res: any = await getTrackPlanLog({ trackPlanId })
      setLoading(false)
      if (res) {
        return res
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  // 画像标签
  const fetchDrawTags = async (bizOpId: string) => {
    try {
      const res: any = await queryAllTags(bizOpId)
      if (res) {
        setDrawTagList(res)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 服务人员
  const fetchTrackPlanRelatives = async (trackPlanId: any) => {
    try {
      setLoading(true)
      const res: any = await getTrackPlanRelatives({ trackPlanId })
      setLoading(false)
      if (res) {
        return res
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  const changeInfoChoice = async (event: any, id: string) => {
    try {
      if (event?.target?.value === 'a') {
        const newList = trackPlanInfoList?.map(plan => {
          if (plan?.id === id) {
            return {
              ...plan,
              infoChoice: 'a',
            }
          }
          return {
            ...plan,
          }
        })
        setTrackPlanInfoList(newList)
        return
      }
      if (event?.target?.value === 'b') {
        const res = await fetchTrackPlanLog(id)
        if (res) {
          const newList = trackPlanInfoList?.map(plan => {
            if (plan?.id === id) {
              return {
                ...plan,
                trackPlanLogInfo: res,
                infoChoice: 'b',
              }
            }
            return {
              ...plan,
            }
          })
          setTrackPlanInfoList(newList)
          return
        }
      }
      if (event?.target?.value === 'c') {
        const res = await fetchTrackPlanRelatives(id)
        if (res) {
          const newList = trackPlanInfoList?.map(plan => {
            if (plan?.id === id) {
              return {
                ...plan,
                trackPlanReletiveInfo: res,
                infoChoice: 'c',
              }
            }
            return {
              ...plan,
            }
          })
          setTrackPlanInfoList(newList)
          return
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const changeBoardChoice = (event: any) => {
    setBoardChoice(event?.target?.value)
  }

  //大tab 画像 跟进 订单
  const items = [
    {
      key: '1',
      label: '跟进',
      children: (
        <>
          {trackPlanInfoList?.map(trackPlanInfo => (
            <div className={styles.follow}>
              <div className={styles.followUp}>
                <div className={styles.followStart}>
                  <div style={{ paddingRight: 30 }}>
                    楼盘：{trackPlanInfo?.houseInfo?.buildingName}
                  </div>
                  <div style={{ paddingRight: 30 }}>
                    跟进门店：{trackPlanInfo?.houseInfo?.orgName}
                  </div>
                  <div className={styles.userTagBox} style={{ padding: '4px 10px' }}>
                    {trackPlanInfo?.statusName}
                  </div>
                  {location?.state?.statusName && (
                    <Tag color="blue">{location?.state?.statusName}</Tag>
                  )}
                </div>
                <div>
                  {trackPlanInfo?.lastFollowTime
                    ? dayjs(trackPlanInfo?.lastFollowTime).format('YYYY-MM-DD HH:mm:ss')
                    : ''}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginTop: 20,
                }}
              >
                <Radio.Group
                  defaultValue={trackPlanInfo?.infoChoice}
                  buttonStyle="solid"
                  onChange={e => changeInfoChoice(e, trackPlanInfo?.id)}
                >
                  <Radio.Button value="a">基本信息</Radio.Button>
                  <Radio.Button value="b">跟进记录</Radio.Button>
                  <Radio.Button value="c">服务人员</Radio.Button>
                </Radio.Group>
              </div>
              {trackPlanInfo?.infoChoice === 'a' && (
                <BasicInfo basicInfo={trackPlanInfo} editTag={false} />
              )}
              {trackPlanInfo?.infoChoice === 'b' && (
                <FollowRecord basicInfo={trackPlanInfo?.trackPlanLogInfo} />
              )}
              {trackPlanInfo?.infoChoice === 'c' && (
                <ServiorInfo basicInfo={trackPlanInfo?.trackPlanReletiveInfo} hidden={true} />
              )}
            </div>
          ))}
        </>
      ),
    },
    {
      key: '2',
      label: '画像',
      children: (
        <>
          <div style={{ padding: '5px 20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Radio.Group
                defaultValue={boardChoice}
                buttonStyle="solid"
                onChange={changeBoardChoice}
              >
                <Radio.Button value="a">标签</Radio.Button>
                <Radio.Button value="b">行为动态</Radio.Button>
              </Radio.Group>
            </div>
            {boardChoice === 'a' && (
              <div style={{ marginTop: '20px' }}>
                {drawTagList?.length !== 0 &&
                  drawTagList?.map(tagItem => (
                    <div style={{ marginBottom: '5px' }}>
                      <div
                        style={{
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '20px',
                          color: 'rgba(135, 136, 138, 1)',
                          marginBottom: '5px',
                        }}
                      >
                        {tagItem?.type === 'content'
                          ? `内容标签：${tagItem?.trackPlanId}`
                          : `销售计划：${tagItem?.trackPlanId}`}
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          width: 'fit-content',
                        }}
                      >
                        {tagItem?.tags ? (
                          tagItem?.tags?.map((tag, index) => (
                            <div
                              className={styles.tag}
                              style={{
                                border: `1px solid ${colorList[index % 4]?.borderColor}`,
                                color: colorList[index % 4]?.fontColor,
                              }}
                            >
                              {tag?.tagName}
                            </div>
                          ))
                        ) : (
                          <div>暂无</div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            )}
            {boardChoice === 'b' && (
              <Card size="small" style={{ borderWidth: 0 }}>
                {/*<STitle title={'行为动态'} />
                  <Timeline style={{ marginTop: 15 }} items={behaviorList} />*/}
                <div>暂无</div>
              </Card>
            )}
          </div>
        </>
      ),
    },
    {
      key: '3',
      label: '订单',
      children: <OrderInfo type="customer" editId={customerId} />,
    },
  ]

  return (
    <SBack
      title={`详情`}
      level={2}
      titleStyle={{  position: 'sticky', top: 0, zIndex: 10 }}
    >
      <div className={styles.detailsMain}>
        <Spin spinning={loading}>
          <Row style={{ marginTop: '5px', height: 'calc(100% - 62px)' }}>
            <Col span={5}>
              <div className={styles.leftInfo} style={{ height: '100%', overflow: 'scroll' }}>
                <div className={styles.detailsMainFlex}>
                  <Avatar size={70} src={detailsInfo?.memberInfo?.imageUrl || avatarNew} />
                  <div
                    style={{ marginTop: 10, marginBottom: 15, textAlign: 'center', fontSize: 18 }}
                  >
                    <div>{detailsInfo?.customerInfo?.name}</div>
                    <div>{detailsInfo?.customerInfo?.phone}</div>
                  </div>
                  <Row gutter={[0, 10]}>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>性别：</span>
                        {detailsInfo?.customerInfo?.gender}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>年龄：</span>
                        {detailsInfo?.customerInfo?.age}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>生日：</span>
                        {detailsInfo?.customerInfo?.birthday
                          ? dayjs(detailsInfo?.customerInfo?.birthday).format('YYYY-MM-DD')
                          : ''}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>职业：</span>
                        {detailsInfo?.customerInfo?.careerName}
                      </div>
                    </Col>
                    <Col className="gutter-row" span={24}>
                      <div>
                        <span className={styles.fontColor}>邮箱：</span>
                        {detailsInfo?.customerInfo?.email}
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* 如果该客户是注册会员，则显示该模块信息，如果不是则不显示 */}
                {detailsInfo?.customerInfo?.memberFlag && (
                  <>
                    <Divider style={{ margin: '10px 0' }} />
                    <div className={styles.flexBetween}>会员信息</div>
                    <div style={{ marginTop: 15 }}>
                      <Row gutter={[0, 10]}>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员ID：</span>
                            {detailsInfo?.memberInfo?.id}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员名称：</span>
                            {detailsInfo?.memberInfo?.name}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员积分：</span>
                            {detailsInfo?.memberInfo?.integralValue}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员成长值：</span>
                            {detailsInfo?.memberInfo?.growValue}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>会员等级：</span>
                            {detailsInfo?.memberInfo?.levelName}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>最近访问时间：</span>
                            {detailsInfo?.memberInfo?.lastLoginTime
                              ? dayjs(detailsInfo?.memberInfo?.lastLoginTime).format('YYYY-MM-DD HH:mm:ss')
                              : ''}
                          </div>
                        </Col>
                        <Col className="gutter-row" span={24}>
                          <div>
                            <span className={styles.fontColor}>入会时间：</span>
                            {detailsInfo?.memberInfo?.createdTime
                              ? dayjs(detailsInfo?.memberInfo?.createdTime).format('YYYY-MM-DD HH:mm:ss')
                              : ''}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </>
                )}
              </div>
            </Col>
            <Col span={19} style={{ height: '100%' }}>
              <div className={styles.rightInfo}>
                <SListTabs items={items} hideExtra={false} />
              </div>
            </Col>
          </Row>
        </Spin>
        {isVisible ? (
          <SelectLabel
            open={isVisible}
            rest={{ id: 1 }}
            onClose={() => {
              setIsVisible(false)
            }}
            fn={() => console.log('测试')}
          />
        ) : null}
      </div>
    </SBack>
  )
}
export default props => {
  return <Details {...props} />
}
